import {
    URLAPI,
    ITEM_VEHICLE_MAINTENANCE_CREATE_PATH,
    ITEM_VEHICLE_MAINTENANCE_UPDATE_PATH,
    DATE_MAINTENANCE_UPDATE_PATH,
    VEHICLE_MAINTENANCE_REPORT_PATH,
} from "../config/index";
import {LOGOUT} from './users';
import axios from "axios";

const init = {
    _create_item_vehicle_maintenance: {
        data: {},
        status: 0,
        message: {},
    },
    _update_item_vehicle_maintenance: {
        data: {},
        status: 0,
        message: {},
    },
    _update_date_maintenance: {
        data: {},
        status: 0,
        message: {},
    },
    _get_report: {
        data: {},
        status: 0,
        message: "",
    },
};

export const CREATE_ITEM_VEHICLE_MAINTENANCE = "CREATE_ITEM_VEHICLE_MAINTENANCE";
export const UPDATE_ITEM_VEHICLE_MAINTENANCE = "UPDATE_ITEM_VEHICLE_MAINTENANCE";
export const UPDATE_DATE_MAINTENANCE = "UPDATE_DATE_MAINTENANCE";
export const GET_REPORT = "GET_REPORT";

export const item_vehicle_maintenance_module = (state = init, action) => {
    switch (action.type) {
        case CREATE_ITEM_VEHICLE_MAINTENANCE:
            return {
                ...state,
                _create_item_vehicle_maintenance: action.payload,
            };
        case UPDATE_ITEM_VEHICLE_MAINTENANCE:
            return {
                ...state,
                _update_item_vehicle_maintenance: action.payload,
            };
        case UPDATE_DATE_MAINTENANCE:
            return {
                ...state,
                _update_date_maintenance: action.payload,
            };
        case GET_REPORT:
            return {
                ...state,
                _get_report: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};


export const createItemVehicleMaintenance = (token, data) => async (dispatch) => {
    try {
        const response = await axios.post(
            `${URLAPI}${ITEM_VEHICLE_MAINTENANCE_CREATE_PATH}`,
            data,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_ITEM_VEHICLE_MAINTENANCE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_ITEM_VEHICLE_MAINTENANCE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_ITEM_VEHICLE_MAINTENANCE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateItemVehicleMaintenance = (token, id, data) => async (dispatch) => {
    try {
        const response = await axios.patch(
            `${URLAPI}${ITEM_VEHICLE_MAINTENANCE_UPDATE_PATH}${id}/`,
            data,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_ITEM_VEHICLE_MAINTENANCE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_ITEM_VEHICLE_MAINTENANCE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_ITEM_VEHICLE_MAINTENANCE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const itemVehicleMaintenanceUpdate = (token, id, data) => async (dispatch) => {
    try {
        const response = await axios.patch(
            `${URLAPI}${DATE_MAINTENANCE_UPDATE_PATH}${id}/`,
            data,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_DATE_MAINTENANCE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_DATE_MAINTENANCE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_DATE_MAINTENANCE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const get_report = (data, token) => async (dispatch) => {
    try {
        const res = await axios.post(URLAPI + VEHICLE_MAINTENANCE_REPORT_PATH, data, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });

        dispatch({
            type: GET_REPORT,
            payload: {
                data: res.data,
                status: res.status,
                message: "",
            },
        });
    } catch (e) {
        dispatch({
            type: GET_REPORT,
            payload: {
                data: {},
                status: 500,
                message: "Ocurrio un error al generar el reporte",
            },
        });
    }
};

export const clear_item_vehicle_maintenance = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
